import { render, staticRenderFns } from "./contant.vue?vue&type=template&id=32018dc6&scoped=true&"
import script from "./contant.vue?vue&type=script&lang=js&"
export * from "./contant.vue?vue&type=script&lang=js&"
import style0 from "./contant.vue?vue&type=style&index=0&id=32018dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32018dc6",
  null
  
)

export default component.exports